import DynamicGridPdf from 'components/v2/compiler/grids/lca-results/DynamicGridPdf';
import FixedGridPdf from 'components/v2/compiler/grids/lca-results/FixedGridPdf';
import React from 'react';
import { CpcrPerformanceTableModel } from 'types/types';
import { PdfAreaDontBreak, PdfH1, PdfH2, PdfPage } from './Styles.styled';
import usePdfData from './utils/usePdfData';

const TechPerformancePage: React.FC = () => {
  const { cpcrSpecificData } = usePdfData();
  if (cpcrSpecificData == null) {
    return null;
  }
  const isTableFilledIn = (table: CpcrPerformanceTableModel) => {
    const tableColumns = cpcrSpecificData.columns.filter((c) => c.tableCode === table.tableCode);
    const columnsFields = (table.isFixed ? tableColumns.slice(1) : tableColumns).map((col) => `a${col.ord}`);
    const filteredDataByTableCode = cpcrSpecificData.data.filter((row) => row.tableCode === table.tableCode);
    const isTableFilledIn = filteredDataByTableCode.some((row) => columnsFields.some((col) => row[col as keyof typeof row]));

    return isTableFilledIn;
  };

  const isThereAnythingToDisplay = cpcrSpecificData.tables.some((t) => isTableFilledIn(t));

  if (!isThereAnythingToDisplay) {
    return null;
  }

  return (
    <PdfPage className="landscape">
      <PdfH1>Technical characteristics and performance</PdfH1>
      {cpcrSpecificData?.tables?.map((t: CpcrPerformanceTableModel) => {
        return (
          isTableFilledIn(t) && (
            <React.Fragment key={t.tableCode}>
              {t.isFixed ? (
                <PdfAreaDontBreak>
                  <PdfH2>{t.tableTitle}</PdfH2>
                  <FixedGridPdf
                    columns={cpcrSpecificData.columns.filter((x) => x.tableCode == t.tableCode)}
                    value={cpcrSpecificData.data.filter((x) => x.tableCode == t.tableCode) || []}
                  />
                  <br />
                </PdfAreaDontBreak>
              ) : (
                (cpcrSpecificData.data?.filter((x) => x.tableCode == t.tableCode) || []).length > 0 && (
                  <PdfAreaDontBreak>
                    <PdfH2>{t.tableTitle}</PdfH2>
                    <DynamicGridPdf
                      columns={cpcrSpecificData.columns.filter((x) => x.tableCode == t.tableCode)}
                      value={cpcrSpecificData.data.filter((x) => x.tableCode == t.tableCode) || []}
                    />
                    <br />
                  </PdfAreaDontBreak>
                )
              )}
            </React.Fragment>
          )
        );
      })}
    </PdfPage>
  );
};

export default TechPerformancePage;
